module.exports = __webpack_public_path__ + "img/brouillardCommunication.f91f84e6.png";